import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../../config';

export const ChartToolbar = ({ pair, onPair, tf, onTf, quote, setup }) => {
  const [pairs, setPairs] = useState([pair]);
  const [tfs, setTfs] = useState(['1m', '5m', '15m', '1h']);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/sim/pairs`).then(({ data }) => { setPairs(data.pairs); setTfs(data.timeframes); }).catch(() => {});
  }, []);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-white/5 px-4 py-3" data-testid="chart-toolbar">
      <div className="flex flex-wrap items-center gap-3">
        <select value={pair} onChange={(e) => onPair(e.target.value)} className="sim-select" data-testid="pair-select">
          {(pairs.includes(pair) ? pairs : [pair, ...pairs]).map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
        <div className="flex items-center gap-2">
          <span className="sim-live-dot" />
          <span className="sim-mono text-lg font-semibold text-white" data-testid="live-price">
            {quote ? quote.price.toFixed(quote.digits) : '—'}
          </span>
        </div>
        {setup && (
          <span className="rounded-full bg-sky-500/10 px-3 py-1 text-xs text-sky-300" data-testid="chart-setup-label">
            From alert: {setup.skull ? '💀 ' : ''}{setup.mt5_date} · MT5 {setup.mt5_time}
          </span>
        )}
      </div>
      <div className="flex items-center gap-1">
        {tfs.map((t) => (
          <button key={t} type="button" onClick={() => onTf(t)} className={`sim-tf ${tf === t ? 'sim-tf-active' : ''}`} data-testid={`tf-${t}`}>
            {t.toUpperCase()}
          </button>
        ))}
      </div>
    </div>
  );
};
